import React , {Component,Fragment} from 'react';
import Fade from 'react-reveal/Fade';
import ReactResizeDetector from 'react-resize-detector';
import ProjectTables from '../reusable/ProjectTables';
import rawProjects from '../../rawDatas/project-highlight-19-Juli.json';
import RandomProjectImage from '../reusable/RandomProjectImage';

export default class Project extends Component{
    constructor(props){
        super(props);
        this.state = {
            picture : 0,
            projects : rawProjects
        };
        this.handleWidth = this.handleWidth.bind(this);
    }

    handleWidth(){
        this.setState({width: window.innerWidth});
    }

    render(){
        return(
            <Fragment>
                <ReactResizeDetector handleWidth onResize={this.handleWidth} />
                <div className="container mt-5 mb-5">
                    <h1 className="mb-5">Proyek MEP Utama</h1>
                    {this.state.projects.map((project) => {
                            let i = Math.floor((Math.random() * 5) + 1);
                            return(
                                <div className="row w-100 p-2 mb-5 mx-0">
                                    <div className="col-sm-7">
                                       <Fade>
                                            <h2>{project.title}</h2>
                                            <ul>
                                                {project.jobs.map((job) => {
                                                    return(
                                                        <li>
                                                            <h4>
                                                                {job}
                                                            </h4>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                       </Fade>
                                    </div>
                                    
                                    <div className="col-5">
                                        <RandomProjectImage images={project.images}/>
                                    </div>
                                </div>
                            );
                    })}

                    <h1 className="mb-5">Refrensi Proyek</h1>
                    <ProjectTables language="id"/>
                </div>
            </Fragment>
        );
    }
}


  